// import './bootstrap-icons.css'
import { useEffect, useState } from 'react'
import { loadDomainSpecificCSS } from './global/GlobalCss'
// import './App.css'
import React from 'react'
//import AppRoutes from './routes/AppRoutes.tsx'
import { useSelector } from 'react-redux'
import AppRoutes from './Routes/AppRoutes'
import { useDispatch } from 'react-redux'
import { AppDispatch, RootState } from './global/config/store'
import { fetchClientList } from './global/config/Reducer/clientSlice'
import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import "../src/assets/extraStyle.css"



function App () {
      const loading = useSelector((state: any) => state.loader.isLoading);
  //  const loader = useSelector((store: any) => store.redirect)
  // const dispatch = useDispatch<AppDispatch>();
  // useEffect(() => {
  //   dispatch(fetchClientList());
  // }, [dispatch]);
  useEffect(() => {
    loadDomainSpecificCSS()
  }, [])
  return (
    <div className='App'>
      <AppRoutes />
      {loading && (
        <div
          className='loader-overlay'
          // style={{ display: `${loader ? 'flex' : 'none'}` }}
        >
          <div className='spinner'>
            <div className='clip-loader'></div>
          </div>
        </div>
      )}
    </div>
  )
}
export default App
